import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTimeMostOfTheTimeGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M27.02 24.68c-.62 0-.65-.55-.65-.66 0-.15.04-.63.61-.63 3.1 0 6.71-2.18 6.71-8.34v-6.3a.74.74 0 0 0-.74-.75h-17.2c-.41 0-.75.34-.75.75v6.31c0 5.75 3.89 8.34 6.65 8.34.25 0 .43.06.55.19.1.1.15.25.15.41 0 .32-.21.7-.78.7-3.18 0-6.55 2.82-6.55 8.04v6.52c0 .41.34.75.75.75h17.2c.41 0 .75-.34.75-.75v-6.52c-.01-4.52-2.95-8.06-6.7-8.06ZM16.51 38.5v-5.77c0-4.25 2.6-6.54 5.05-6.54 1.48 0 2.28-1.13 2.28-2.2 0-.55-.2-1.06-.57-1.45-.27-.29-.78-.64-1.62-.64-2.14 0-5.15-2.12-5.15-6.84V9.5h15.7v5.56c0 4.28-1.95 6.84-5.21 6.84-1.39 0-2.11 1.07-2.11 2.13 0 .55.19 1.07.54 1.47.4.45.97.7 1.61.7 2.91 0 5.19 2.87 5.19 6.54v5.76H16.51Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M25.75 27.08h-2.9c-2.87 0-5.2 2.33-5.2 5.2v4.25c0 .52.42.95.95.95H30c.52 0 .95-.42.95-.95v-4.25c0-2.87-2.33-5.2-5.2-5.2ZM30.95 15.94v-.85a.95.95 0 0 0-.95-.95H18.6a.95.95 0 0 0-.95.95v.85c0 2.87 2.33 5.2 5.2 5.2h2.9c2.87.01 5.2-2.32 5.2-5.2Z",
    fill: "currentColor"
  }));
}

export { SvgTimeMostOfTheTimeGlyphSecondary as default };
